/**
 * @description: 支付流水
 * @author: hwx
 */
<template>
	<div class="flow-manage-wrap">
		<div class="flow-list" v-show="!showdetail">
			<h1>支付流水</h1>
			<div class="row row-margin">
				<label class="list-label-4">支付时间:</label>
				<div class="col-md-3 list-time">
					<div ref="time">
						<input type="text" class="form-control laydate-icon" v-model="start_time"> -
						<input type="text" class="form-control laydate-icon" v-model="end_time">
					</div>
				</div>
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="flow_shop"></select>
				</div>
				<label class="list-label-4">支付类型:</label>
				<div class="col-md-2 ct-col">
					<input type="text" class="form-control" v-model="pay_type_str" placeholder="请选择支付类型" @click="openPayTypePop">
				</div>
			</div>
			<div class="row row-margin">
				<label class="list-label-5">支付操作人:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="flow_admin"></select>
				</div>
			</div>
			<div class="row">
				<label class="list-label-4">实收金额:</label>
				<div class="list-total">{{ actual_amount_total }} 元</div>
				<label class="list-label-4">退款总额:</label>
				<div class="list-total">{{ refund_amount_total }} 元</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="flowQuery">查询</button>
					<button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getExportSet">导出</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="flow_list"></table>
			</div>
			<!-- 支付类型弹窗 -->
	        <div class="pay-type-pop ele-hide" ref="pay_type_pop">
	            <el-checkbox v-model="checkAllPayType" @change="handleCheckAllChange">全选</el-checkbox>
	            <el-checkbox-group v-model="choosed_pay_type" @change="handleCheckedPayTypeChange">
	                <el-checkbox v-for="item in pay_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
	            </el-checkbox-group>
	        </div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="create_time">
							<label>支付时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="shop_name">
							<label>门店</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="admin_name">
							<label>支付操作人</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="actual_pay">
							<label>实收金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="refund_amount">
							<label>退款金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="pay_platform_show">
							<label>支付类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="bill_no">
							<label>对应账单</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 账单详情 -->
		<div class="flow-bill-det" v-show="showdetail">
			<billDetail ref="flow_bill_det" @backBdwPre="showdetail = false"></billDetail>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import billDetail from '@/components/bill_detail.vue';
	export default {
		name: '',
		data() {
			return {
				showdetail: false,
				list_total: '',
				start_time: '',
				end_time: '',
				actual_amount_total: '',
				refund_amount_total: '',
				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['create_time', 'shop_name', 'admin_name', 'actual_pay', 'refund_amount', 'pay_platform_show', 'bill_no'],
				export_type: 1,
				pay_type_list: [], // 支付类型列表
                checkAllPayType: false,
                choosed_pay_type: [],
                pay_type_str: '',
			}
		},
		components: {
			"billDetail": billDetail
		},
		watch: {
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			// 日期
			this.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
			this.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
			this.initDate();
			this.initShop();
		},
		methods: {
			// 初始化日期插件
			initDate: function() {
				const _this = this;
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: moment().hour(8).minute(0).toDate(),
					endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
					dateLimit: {
						days: 31
					},
				}, function(start, end, label) {
					_this.start_time = start.format('YYYY-MM-DD HH:mm');
					_this.end_time = end.format('YYYY-MM-DD HH:mm');
				});
			},
			// 初始化门店
			initShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [];
						res.data.response.result.forEach(v => {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.flow_shop).select2({
							data: arr,
							allowClear: true,
							minimumResultsForSearch: -1,
							language: "zh-CN"
						}).on("select2:select", function(e) {
							// 获取支付类型
							_this.getPaytype(e.params.data.id);
							_this.getAdmin(e.params.data.id);
						});
						$(_this.$refs.flow_shop).val(res.data.response.result[1].id).trigger('change');
						// 获取支付类型
						_this.getPaytype(res.data.response.result[1].id);
						_this.getAdmin(res.data.response.result[1].id);

						// 
						_this.initTable();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 获取支付类型
			getPaytype: function(shop_id) {
				const _this = this;

				Vue.axios.post('Order/getAllPayPlatform', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.pay_type_list = []
                        let arr = res.data.response.data
                        for(let k in arr) {
                            _this.pay_type_list.push({
                                id: k,
                                name: arr[k]
                            })
                        }
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			handleCheckAllChange(val) {
                this.choosed_pay_type = []
                if (!!val) {
                    this.pay_type_list.forEach(item => {
                        this.choosed_pay_type.push(item.id)
                    })
                }
            },
            handleCheckedPayTypeChange(value) {
                let checkedCount = value.length;
                this.checkAllPayType = checkedCount === this.pay_type_list.length;
            },

            // 打开显示字段选择弹窗
            openPayTypePop() {
                let _this = this
                let c_checkAllPayType = _this.checkAllPayType
                let c_choosed_pay_type = _this.choosed_pay_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择支付类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.pay_type_pop),
                    cancel: function() {
                        _this.checkAllPayType = c_checkAllPayType
                        _this.choosed_pay_type = c_choosed_pay_type
                    },
                }, function() {
                    if (_this.choosed_pay_type.length < 1) {
                        layer.msg("请选择支付类型")
                        return
                    }
                    if (_this.checkAllPayType) { // 全选
                        _this.pay_type_str = '全部'
                    }else {
                        let arr = []
                        _this.choosed_pay_type.forEach(item => {
                            _this.pay_type_list.forEach(v => {
                                if (item == v.id) {
                                    arr.push(v.name)
                                }
                            })
                        })
                        _this.pay_type_str = arr.join(",")
                    }
                    layer.closeAll()
                }, function() {
                    _this.checkAllPayType = c_checkAllPayType
                    _this.choosed_pay_type = c_choosed_pay_type
                });
            },

			// 获取操作人
			getAdmin: function(shop_id) {
				const _this = this;

				Vue.axios.post('User/getList', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [{ id: "0", text: "全部" }];
						res.data.response.result.user_info.forEach(v => {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.flow_admin).html("");
						$(_this.$refs.flow_admin).select2({
							data: arr,
							language: "zh-CN",
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 初始化列表
			initTable: function() {
				const _this = this;

				$(_this.$refs.flow_list).bootstrapTable('destroy');
				$(_this.$refs.flow_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					showJumpto: true,
					pagination: true,
					ajax: function(params) {
						_this.getFlowList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "create_time",
						title: "支付时间",
						width: "10%",
						valign: "middle"
					}, {
						field: "shop_name",
						title: "门店",
						width: "10%",
						valign: "middle"
					}, {
						field: "admin_name",
						title: "支付操作人",
						width: "10%",
						valign: "middle"
					}, {
						field: "actual_pay",
						title: "实收金额",
						width: "10%",
						valign: "middle"
					}, {
						field: "refund_amount",
						title: "退款金额",
						width: "10%",
						valign: "middle"
					}, {
						field: "pay_platform_show",
						title: "支付类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "bill_no",
						title: "对应账单",
						width: "10%",
						valign: "middle",
						events: {
							'click .billno': function(e, value, row) {
								_this.$refs.flow_bill_det.getBdwDetail(value);
								_this.showdetail = true;
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue billno">'+ value +'</span>'
						}
					}],
				});
			},
			getFlowList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				Vue.axios.post('PayLog/getList', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.start_time,
							"end_time": _this.end_time,
							"shop_id": $(_this.$refs.flow_shop).val(),
							"pay_platform_arr": _this.choosed_pay_type,
							"admin_id": $(_this.$refs.flow_admin).val()
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(pageNumber == '1') {
							_this.list_total = res.data.response.result.count;
							_this.actual_amount_total = res.data.response.result.total_actual_pay;
							_this.refund_amount_total = res.data.response.result.total_refund_amount;
						}
						params.success({
							total: _this.list_total,
							rows: res.data.response.result.data
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			flowQuery: function() {
				this.initTable();
			},
			// 获取导出设置
			getExportSet: function() {
				const _this = this;

				Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "PayLog/export"
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
							_this.export_checkModel = res.data.response.result.export_fields;
							_this.export_type = res.data.response.result.export_type;
						} else {
							_this.export_checkModel = _this.export_checkData;
							_this.export_type = 1;
						}
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportList();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				const _this = this;

				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(v => {
						_this.export_checkModel.push(v);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 点击“导出”按钮
			exportList: function() {
				const _this = this;

				const export_fields = JSON.stringify(_this.export_checkModel);
				window.location.href = Vue.ctUrl +
					"PayLog/export?" +
					"start_time=" + _this.start_time +
					"&end_time=" + _this.end_time +
					"&shop_id=" + $(_this.$refs.flow_shop).val() +
					"&pay_platform_arr=" + _this.choosed_pay_type +
					"&admin_id=" + $(_this.$refs.flow_admin).val() +
					"&export_fields=" + export_fields +
					"&export_type=" + _this.export_type;
				
				layer.closeAll();
				layer.msg("导出成功！");
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.flow-manage-wrap {
		.flow-list {
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
			}
			.set-export {
				padding: 0 20px 20px;
				h3 {
					font-size: 16px;
				}
				li {
					float: left;
					width: 20%;
				}
			}
		}
		.pay-type-pop {
	        .el-checkbox {
	            width: 150px;
	            margin: 10px 10px 0 0;
	        }
	    }
	}
</style>